module.exports = __webpack_public_path__ + "img/shinji.4e90d5f9.jpg";